import getRegion from 'shared/lib/getRegion';
import { isAndroid } from './useragentdetection';

// Launch native app share UI
function shareHandler({ url, title, description, image }) {
  if (isAndroid()) {
    window.android.shareUrl(url, title, description, image || '');
  } else {
    window.webkit.messageHandlers.shareUrl.postMessage(JSON.stringify({ url, title, description, image }));
  }
}

function legacyReserveHandler() {
  if (isAndroid()) {
    window.android.startReservation();
  } else {
    window.webkit.messageHandlers.startReservation.postMessage({status:'ready' });
  }
}

// Launch native app reserve UI
function reserveHandler(edition) {
  if (isAndroid()) {
    window.android.startReservation(edition);
  } else {
    window.webkit.messageHandlers.startReservation.postMessage({status:'ready', edition });
  }
}

// Launch 3D tour
function tourHandler() {
  if (isAndroid()) {
    const region = getRegion(window.location.href);
    window.android.startView3DTour(
      region === 'US' ? 'https://www.ff.com/us/3D-tour/' : 'https://www.faradayfuturecn.com/cn/3D-tour/'
    );
  } else {
    window.webkit.messageHandlers.startView3DTour.postMessage({status:'ready'})
  }
}

// Launch configurator
function configuratorHandler() {
  if (isAndroid()) {
    window.android.startViewConfigurator();
  } else {
    window.webkit.messageHandlers.startViewConfigurator.postMessage({status:'ready'})
  }
}

// Launch product page
function startViewProductPageHandler() {
  if (isAndroid()) {
    window.android.startViewProductPage();
  } else {
    window.webkit.messageHandlers.startViewProductPage.postMessage({status:'ready'})
  }
}

// Launch product page
function startViewAllianceProductPageHandler() {
  if (isAndroid()) {
    window.android.startViewProductPage('alliance');
  } else {
    window.webkit.messageHandlers.startViewProductPage.postMessage({ edition: 'alliance' })
  }
}

// Launch product page
function startViewFuturistProductPageHandler() {
  if (isAndroid()) {
    window.android.startViewProductPage('futurist');
  } else {
    window.webkit.messageHandlers.startViewProductPage.postMessage({ edition: 'futurist' })
  }
}

// Open configurator with subscribe modal open
function startReservationWithFF91Subscribe() {
  const configuratorPath = '/us/design/2022/FF91/model?FF91_SUBSCRIBE=1&APPONLY=1';
  if (isAndroid()) {
    window.android.openConfigurator(configuratorPath);
  } else {
    window.webkit.messageHandlers.openConfigurator.postMessage({ configuratorPath })
  }
}

// Open configurator with alliance page
function startReservationWithAlliance() {
  const configuratorPath = '/us/design/2022/FF91/options?VEH=FF91FNA-ALLIANCE&APPONLY=1';
  if (isAndroid()) {
    window.android.openConfigurator(configuratorPath);
  } else {
    window.webkit.messageHandlers.openConfigurator.postMessage({ configuratorPath })
  }
}

// Open configurator with futurist page
function startReservationWithFuturist() {
  const configuratorPath = '/us/design/2022/FF91/options?VEH=FF91FNA&APPONLY=1';
  if (isAndroid()) {
    window.android.openConfigurator(configuratorPath);
  } else {
    window.webkit.messageHandlers.openConfigurator.postMessage({ configuratorPath })
  }
}

// Close the current webview
function closeWebviewHandler() {
  if (isAndroid()) {
    window.android.closeWebview();
  } else {
    window.webkit.messageHandlers.closeWebview.postMessage({})
  }
}

// Open ecoProduct product page
function ecosystemProductPageHandler() {
  const region = getRegion(window.location.href);

  const path = region === 'US' ? '/us/app/ecosystem-product/?APPONLY=1' : '/cn/app/ecosystem-product/?APPONLY=1';
  const title = '';
  const hiddenNav = 'true'; // string

  if (isAndroid()) {
    window.android.openPage(path, title, hiddenNav);
  } else {
    window.webkit.messageHandlers.openPage.postMessage({ path, title, hiddenNav })
  }
}

// Open ecoProduct preorder page
function ecosystemProductPreorderPageHandler() {
  const region = getRegion(window.location.href);

  const path = region === 'US' ? '/us/h5/ecosystem-product-preorder' : '/cn/h5/ecosystem-product-preorder';
  const title = 'FF aiHypercar+';
  const hiddenNav = 'false'; // string

  if (isAndroid()) {
    window.android.openPage(path, title, hiddenNav);
  } else {
    window.webkit.messageHandlers.openPage.postMessage({ path, title, hiddenNav })
  }
}

// Open ff91 preorder page
function ff91PreorderPageHandler() {
  const region = getRegion(window.location.href);

  const path = region === 'US' ? '/us/h5/ff-91-preorder' : '/cn/h5/ff-91-preorder';
  const title = 'FF 91 2.0 Preorder';
  const hiddenNav = 'false'; // string

  if (isAndroid()) {
    window.android.openPage(path, title, hiddenNav);
  } else {
    window.webkit.messageHandlers.openPage.postMessage({ path, title, hiddenNav })
  }
}

// Open ff91 futurist preorder page
function ff91FuturistPreorderPageHandler() {
  const path = '/us/h5/ff-91-Futurist-preorder'; // This method is only for US, the reserveHandler or legacyReserveHandler are for CN.
  const title = 'FF 91 2.0 Futurist Preorder';
  const hiddenNav = 'false'; // string

  if (isAndroid()) {
    window.android.openPage(path, title, hiddenNav);
  } else {
    window.webkit.messageHandlers.openPage.postMessage({ path, title, hiddenNav })
  }
}

// Open All Ability AIHypercar Page
function allAbilityAiHypercarPageHandler() {
  const region = getRegion(window.location.href);

  const path = region === 'US' ? '/us/app/all-ability-aihypercar/?APPONLY=1' : '/cn/app/all-ability-aihypercar/?APPONLY=1';
  const title = '';
  const hiddenNav = 'true'; // string

  if (isAndroid()) {
    window.android.openPage(path, title, hiddenNav);
  } else {
    window.webkit.messageHandlers.openPage.postMessage({ path, title, hiddenNav })
  }
}

// Open All Ability AIHypercar Page
function aiHypercarArchitecturePageHandler() {
  const region = getRegion(window.location.href);

  const path = region === 'US' ? '/us/app/aihyper-architecture/?APPONLY=1' : '/cn/app/aihyper-architecture/?APPONLY=1';
  const title = '';
  const hiddenNav = 'true'; // string

  if (isAndroid()) {
    window.android.openPage(path, title, hiddenNav);
  } else {
    window.webkit.messageHandlers.openPage.postMessage({ path, title, hiddenNav })
  }
}

// Open FX Simple Preorder Page
function fxSimplePreorderPageHandler() {
  const region = getRegion(window.location.href);
  const path = region === 'US' ? '/us/h5/fx-preorder' : '/cn/h5/fx-preorder';
  const title = 'Preorder Faraday X';
  const hiddenNav = 'false'; // string

  if (isAndroid()) {
    window.android.openPage(path, title, hiddenNav);
  } else {
    window.webkit.messageHandlers.openPage.postMessage({ path, title, hiddenNav })
  }
}

export function getHandlerByKey(key, options = {}) {
  if (key === 'Reserve') {
    return () => legacyReserveHandler();
  } else if (key === 'Reserve Alliance (CN)') {
    return () => reserveHandler('91FA');
  } else if (key === 'Reserve Futurist (CN)') {
    return () => reserveHandler('91FS');
  } else if (key === 'Reserve Standard (CN)') {
    return () => reserveHandler('FF91');
  } else if (key === 'Reserve Ecosystem Product (CN)') {
    return () => reserveHandler('ECOPRODUCT');
  } else if (key === 'Reserve Alliance') {
    return () => startReservationWithAlliance();
  } else if (key === 'Reserve Futurist') {
    return () => startReservationWithFuturist();
  } else if (key === 'FF 91 Subscribe') {
    return () => startReservationWithFF91Subscribe();
  } else if (key === '3D Tour') {
    return () => tourHandler();
  } else if (key === 'Share') {
    return () => shareHandler(options);
  } else if (key === 'Configurator') {
    return () => configuratorHandler();
  } else if (key === 'Product Page') {
    return () => startViewProductPageHandler();
  } else if (key === 'Alliance Product Page') {
    return () => startViewAllianceProductPageHandler();
  } else if (key === 'Futurist Product Page') {
    return () => startViewFuturistProductPageHandler();
  } else if (key === 'Close Webview') {
    return () => closeWebviewHandler();
  } else if (key === 'Ecosystem Product') {
    return () => ecosystemProductPageHandler();
  } else if (key === 'Ecosystem Product Preorder') {
    return () => ecosystemProductPreorderPageHandler();
  } else if (key === 'FF 91 Preorder') {
    return () => ff91PreorderPageHandler();
  } else if (key === 'FF 91 Futurist Preorder (US)') {
    return () => ff91FuturistPreorderPageHandler();
  } else if (key === 'AI Hyper Architecture') {
    return () => aiHypercarArchitecturePageHandler();
  } else if (key === 'All Ability AIHypercar') {
    return () => allAbilityAiHypercarPageHandler();
  } else if (key === 'Preorder Faraday X') {
    return () => fxSimplePreorderPageHandler();
  }

  return null;
}
